import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as juridicoApi from '../api/juridico'
import { useSelector } from 'react-redux'

const Juridico = () => {
  const translations = useSelector(state => state.translations.translations)

  const columns = [
    {
      title: "Imagem",
      field: '_id',
      filtering: false,
      sorting: false,
      cellStyle: {
        maxWidth: 66,
      },
      render: rowData =>
        <img
          className="noticia-img"
          src={juridicoApi.getFileJuridico(rowData._id)}
          alt="" />
    },
    {
      title: "Nome",
      field: "name",
      sorting: true
    },
  ];

  // const options = {
  //   filtering: true,
  //   actionsColumnIndex: -1,
  //   paging: false
  // }

  return (
    <React.Fragment>
      <Header title={"Juridico"} subtitle={"Lista de juridico"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            url={'juridico'}
            columns={columns}
            fetchFunction={juridicoApi.fetchItems}
            removeFunction={juridicoApi.removeItem}
            statusFunction={juridicoApi.statusItem}
            enableSearch
          />
        </BigCard>
      </Container>
    </React.Fragment>
  )
}

export default Juridico
